import { render, staticRenderFns } from "./AssignPeers.vue?vue&type=template&id=977bc726&"
import script from "./AssignPeers.vue?vue&type=script&lang=js&"
export * from "./AssignPeers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports